import {useEventBus} from '@vueuse/core'
import Echo from 'laravel-echo'
import {defineStore} from 'pinia'
import Pusher from 'pusher-js'
import {useAuthStore} from './auth'

export const useWebsocketStore = defineStore('websockets', {
    state: () => ({
        channel: null,
        members: {},
        ready: false,
    }),

    getters: {
        /*userActive: (state) => {
            return (userId) => {


            }
        },*/
    },

    actions: {
        async init(mode = 'default') {
            const config = useRuntimeConfig()
            window.Pusher = Pusher
            window.Echo = new Echo({
                broadcaster: 'reverb',
                key: config.public.websockets.key,
                host: config.public.websockets.host,
                httpHost: config.public.websockets.host,
                wsHost: config.public.websockets.host,
                cluster: config.public.websockets.cluster,
                forceTLS: config.public.websockets.forceTLS,
                disableStats: config.public.websockets.disableStats,
                enabledTransports: config.public.websockets.forceWSS ? ['wss'] : ['wss', 'ws'],
                authorizer: (channel: any, options: any) => {
                    return {
                        authorize: async (socketId: any, callback: any) => {
                            await $lara.post("/app/spa/broadcasting/auth", {
                                body: {
                                    socket_id: socketId,
                                    channel_name: channel.name
                                }
                            }).then((response) => {
                                callback(false, response)
                            }).catch(() => {
                                callback(true)
                            })
                        }
                    }
                }
            })

            // Set ready state to prevent undefined Echo
            this.ready = true

            if (mode === 'default') {
                this.joinUserPrivate()
            }

            window.Echo.connector.pusher.connection.bind('state_change', function (states: any) {
                if (states.current === 'disconnected') {
                    window.Echo.connector.pusher.connect()
                }
            })
        },

        joinUserPrivate() {
            if (!useAuthStore().userData?.id) return
            window.Echo.private('App.Models.User.' + useAuthStore().userData.id)
                .notification((notification: any) => {
                    useEventBus('notifications').emit(notification)
                })
                .listen('UserSignatureCreated', (event: any) => {
                    useEventBus('userSignatureCreated').emit(event)
                })
                .error((error: Error) => {
                    useNotification().error(useI18n().t('error'), error.message)
                })
        },

        joinFormProcessPrivate(formProcessId: number) {
            window.Echo.channel(`formProcesses.${formProcessId}`)
                .listen('FormProcessSignatureCreated', (event: any) => {
                    useEventBus('formProcessSignatureCreated').emit(event)
                })
                .listen('FormProcessManagementSignatureCreated', (event: any) => {
                    useEventBus('formProcessManagementSignatureCreated').emit(event)
                })
        },

        joinOrganisationPrivate(organisationId: number) {
            window.Echo.channel(`organisations.${organisationId}`)
                .listen('OrganisationSignatureCreated', (event: any) => {
                    useEventBus('organisationSignatureCreated').emit(event)
                })
        },

        leaveOrganisationPrivate(organisationId: number) {
            window.Echo.leave(`organisations.${organisationId}`)
        }
    }
})